export const GET_SHARED_SERVICES = 'GET_SHARED_SERVICES';
export const getSharedServices = (fulfillmentPlanId) => ({
  type: GET_SHARED_SERVICES,
  fulfillmentPlanId,
});

export const GET_SHARED_SERVICES_SUCCESS = 'GET_SHARED_SERVICES_SUCCESS';
export const getSharedServicesSuccess = (sharedServices, fulfillmentPlanId) => ({
  type: GET_SHARED_SERVICES_SUCCESS,
  sharedServices,
  fulfillmentPlanId,
});

export const GET_SHARED_SERVICES_ERROR = 'GET_SHARED_SERVICES_ERROR';
export const getSharedServicesError = (errors) => ({
  type: GET_SHARED_SERVICES_ERROR,
  errors,
});

export const GET_PARTNER_SHARED_SERVICES_SUCCESS = 'GET_PARTNER_SHARED_SERVICES_SUCCESS';
export const getPartnerSharedServicesSuccess = (services) => ({
  type: GET_PARTNER_SHARED_SERVICES_SUCCESS,
  services,
});
